import { useEffect, useRef } from "react";

type Props = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
};

export function WaveSearchField({
  value,
  onChange,
  placeholder = "Cerca",
}: Props) {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === "k") {
        event.preventDefault();
        inputRef.current?.focus();
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  return (
    <label className="wave-search-field">
      <span className="wave-search-icon" aria-hidden>
        ⌕
      </span>
      <input
        ref={inputRef}
        type="search"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        aria-label={placeholder}
      />
      <span className="wave-search-hint" aria-hidden>
        ⌘K
      </span>
      {value.trim() ? (
        <button
          type="button"
          className="wave-search-clear"
          aria-label="Cancella ricerca"
          onClick={() => onChange("")}
        >
          ×
        </button>
      ) : null}
    </label>
  );
}
